document.addEventListener("DOMContentLoaded", () => {
  // Wait for FoxTheme to be ready before defining the element
  const waitForFoxTheme = setInterval(() => {
    if (window.FoxTheme && window.FoxTheme.Carousel && window.FoxTheme.Swiper) {
      clearInterval(waitForFoxTheme);

      if (!customElements.get('press-slider')) {
        customElements.define(
          'press-slider',
          class PressSlider extends HTMLElement {
            constructor() {
              super();
            }

            connectedCallback() {
              this.main = this.querySelector('.press-testimonials');
              this.thumbs = this.querySelector('.press-thumbs');

              if (!this.main || !this.thumbs) return;

              this.mainSlider = this.main.querySelector('.swiper');
              this.thumbsSlider = this.thumbs.querySelector('.swiper');

              const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
              mql.onchange = this.init.bind(this);
              this.init();
            }

            init() {
              this.destroySlider();
              this.initSlider();
            }

            setSliderOptions() {
              // main slider options
              this.mainOptions = {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                  nextEl: this.main.querySelector('.swiper-button-next'),
                  prevEl: this.main.querySelector('.swiper-button-prev'),
                },
                loop: true,
                threshold: 2,
                grabCursor: true,
                allowTouchMove: true,

                // autoplay for main slider
                autoplay: {
                  delay: 3000, // 3 seconds
                  disableOnInteraction: false,
                },
              };

              const thumbsDesktopItems = Number(this.thumbs.dataset.itemsDesktop);
              const thumbsTabletItems = Number(this.thumbs.dataset.itemsTablet);

              // thumbs options
              this.thumbsOptions = {
                slidesPerView: 'auto',
                spaceBetween: 32,
                breakpoints: {
                  768: {
                    slidesPerView: thumbsTabletItems,
                    spaceBetween: 90,
                  },
                  1024: {
                    slidesPerView: thumbsDesktopItems,
                    spaceBetween: 90,
                  },
                },
                freeMode: true,
                threshold: 2,

                // autoplay for thumbs
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },

                loop: true,
              };

              if (FoxTheme.config.mqlMobile) {
                this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
                  centeredSlides: true,
                  slideToClickedSlide: true,
                  loop: true,
                });
              }
            }

            initSlider() {
              this.setSliderOptions();

              // Initialize thumbsInstance
              this.thumbsInstance = new FoxTheme.Carousel(
                this.thumbsSlider,
                this.thumbsOptions,
                [FoxTheme.Swiper.Autoplay]
              );
              this.thumbsInstance.init();

              // Link thumbs to main
              this.mainOptions.thumbs = {
                swiper: this.thumbsInstance.slider,
                autoScrollOffset: 2,
              };

              // Initialize main slider
              this.sliderInstance = new FoxTheme.Carousel(
                this.mainSlider,
                this.mainOptions,
                [FoxTheme.Swiper.Thumbs, FoxTheme.Swiper.Autoplay]
              );
              this.sliderInstance.init();

              // Sync thumbs with main
              this.sliderInstance.slider.on('realIndexChange', (swiper) => {
                const { realIndex, thumbs } = swiper;
                if (thumbs && thumbs.swiper && typeof thumbs.swiper.slideToLoop === 'function') {
                  thumbs.swiper.slideToLoop(realIndex);
                }
              });
            }

            destroySlider() {
              if (typeof this.sliderInstance !== 'object') return;

              try {
                if (this.sliderInstance && this.sliderInstance.slider && this.sliderInstance.slider.autoplay) {
                  try { this.sliderInstance.slider.autoplay.stop(); } catch (e) {}
                }
                this.sliderInstance.slider.destroy();
              } catch (e) {}
              this.sliderInstance = false;

              try {
                if (this.thumbsInstance && this.thumbsInstance.slider && this.thumbsInstance.slider.autoplay) {
                  try { this.thumbsInstance.slider.autoplay.stop(); } catch (e) {}
                }
                if (this.thumbsInstance && this.thumbsInstance.slider) {
                  this.thumbsInstance.slider.destroy();
                }
              } catch (e) {}
              this.thumbsInstance = false;
            }
          }
        );
      }
    }
  }, 100);
});